import { Theme } from "../../../components/constants";

export default {
    bodyContainer: {
        marginTop: "10px"
    },

    drawerBody: {
        backgroundColor: "#F8FAFB"
    },

    drawerBodyContainerStyles: {
        paddingRight: "16px"
    },

    formContainer: {
        display: "flex",
        flexDirection: "column",
        rowGap: "20px",
    },

    drawerCard: {
        padding: "22px 16px",
    },

    horizontalLine: {
        border: `0.5px solid ${Theme.PRIMARY_BORDER}`,
        margin: "20px 0 20px"
    },

    formInfo: {
        display: "flex",
        justifyContent: "space-between",
        margin: "5px 0 5px"
    },
    tooltipIcon : {
       display: 'inline-flex', 
       alignItems: 'center' 
   },
    popupFlexDirection: {
       flexDirection: 'column'
    },
    marginTopBtn: {
        marginTop: '-25px'
    },
    formName: {
        fontSize: "16px",
        color: Theme.TEXT_PRIMARY_BLACK,
        fontWeight: "500"
    },

    amount: {
        color: Theme.GREEN_TEXT,
        fontWeight: "600"
    },

    individualBox: {
        display: "flex",
        columnGap: "10px",
        marginBottom: "10px"
    },

    individual: {
        color: Theme.TEXT_DARK_GRAY
    },

    totalBox: {
        display: "flex",
        justifyContent: "space-between",
        margin: "20px 0 50px"
    },

    walletText: {
        fontSize: "16px",
        marginTop: "14px"
    },

    nextButtonContainer: {
        textAlign: "right",
        marginTop: "20px"
    },

    nextButton: {
        width: "160px",
        height: "40px",
    },

    drawerBodyStyles: {
        paddingRight: "0px"
    }

}